export default __webpack_public_path__ + "static/media/ldo_FLOAT_ADJ_EN_nCff.3990d6ec.svg";